import { ParentProps, createContext, onMount } from 'solid-js'
import styles from './st-customer-assist.module.css'
import SupportAssist from '../st-support-assist/st-support-assist';

export class CustomerAssistProps { }

export default function CustomerAssist(props: ParentProps<CustomerAssistProps>) {

    return (
        <SupportAssist excludeSensitiveData />
    );
}

CustomerAssist.defaultProps = new CustomerAssistProps();